import React from 'react'
import { connect } from 'react-redux'
import { 
    Cell, CellBody, CellHeader, CellFooter, Toast, Dialog, ActionSheet, Toptips, Mask, Button
} from 'react-weui'
import qs from 'qs'
import axios from 'axios'
import qrcode from 'qrcode'
import { browserHistory } from 'react-router'
import { Page, FollowLiveroom } from '../../components'
import { storage, renderMoney } from '../../utils'
import ScheduleDetailSignins from './ScheduleDetailSignins'
import ScheduleDetailOperation from './ScheduleDetailOperation'
import { WKBottomBtn, WKVisible, WKInfiniteScroll, WKCommentDialog, WkPanel } from '../../components/wk'
import signinsEmptyImg from '../../images/schedule/signins-empty.png'
import signinImg from '../../images/schedule/signin.png'
import signinDisabledImg from '../../images/schedule/signin-disabled.png'
import questionImg from '../../images/question.png'
import panelFeeImg from '../../images/schedule/panel-fee.png'
import panelTimeImg from '../../images/schedule/panel-time.png'
import panelRewardImg from '../../images/schedule/panel-reward.png'
import achieveCardBottomImg from '../../images/schedule/achieve-card-bottom.png'
import {filterHTML} from "../../utils/index";


class SchedulePage extends React.Component {
    constructor (props) {
        super(props)
        this.managerMenu = [{
            label: '回复',
            onClick: () => this.onClickReply(),
        }, {
            label: '删除评论',
            onClick: e => this.onClickDelComment()
        }]
        this.menu = [{
            label: '回复',
            onClick: () => this.onClickReply(),
        }]
        this.state = {
            signins: [],
            scheduleInfo: {},
            accessInfo: {},
            isLike: false,
            likes: [],
            comments: [],
            isShowCommentDialog: false,
            selectedComment: '',
            selectedCommentSignin: '',
            selectedCommentSigninIndex: '',
            selectedCommentIndex: '',
            comment: '',
            audioStatus: 'stop',
            audioDuration: 0,
            audioCurrentTime: 0,
            isShowActionSheet: false,
            audioSrc: '',
            selectedAudioIndex: '',
            signinsOffset: 0,
            isSigninsPending: false,
            signinsHasMore: true,
            isShowQrDialog: false,
            isShowReceiveDialog: false,
            qrImg: '',
            achieveImg: '',
            isshowAchieve: false,
            isDescOn: false,
            isShowDelSigninDialog: false,
            selectedSigninId: '',
            isPending: false,
            stats_info: {},
            isShowPayQuestionDialog: false,
            liveroom: {},
            isFans: false,
            isLocalFollowed: false, // 本地假关注
            isShow404: false,
            isShowDesc: false,
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            isSubscribe: false,
            isShowCanNotJoinDialog: false,
        }
    }
    componentDidMount () {
        document.title = '打卡活动'
        setTimeout(() => {
            window.scrollTo(0,1)
        }, 100)
        this.fetchSignins()
        this.fetchScheduleInfo()
        this.fetchSubscribeInfo()
    }
    fetchSubscribeInfo () {
        axios.get('/api/schedule/subscribe/info')
            .then(res => {
                this.setState({ isSubscribe: res.data.data.subscribed })
            })   
    }
    fetchScheduleInfo () {
        this.setState({ isPending: true })
        axios.get(`/api/schedule/${this.props.params.id}/info`, {
            params: {
                t: Date.now(),
            }
        })
            .then(res => {
                const data = res.data.data
                this.setState({
                    scheduleInfo: data,
                    accessInfo: data.access_info || {},
                    isPending: false,
                    stats_info: data.stats_info,
                    liveroom: data.liveroom,
                    isFans: data.role.is_fans,
                    isShowDesc: !(data.access_info && data.access_info.participate),
                }, () => {
                    if (storage.getItem('schedule_create') || +this.props.location.query.pop_card === 1) {
                        this.fetchAchieveImg()
                    }
                    storage.setItem('schedule_create', false)
                })
                this.initShareInfo(data.share_info)
            })
            .catch(err => {
                if (err.response.status === 404) {
                    browserHistory.replace(`/lecture/error/delete/schedule`)
                    // this.setState({ isShow404: true })
                }
            })
            .then(res => {
                this.setState({ isPending: false })
            })
    }
    fetchAchieveImg () {
        this.setState({ isshowAchieve: true })
        if (!this.state.achieveImg) {
            this.setState({ isPending: true })
            axios.get(`/api/sharecard/${this.state.accessInfo.id}/info`, {
                params: {
                    type: 'schedule_achieve'
                }
            })
                .then(res => {
                    this.setState({ achieveImg: res.data.data.sharecard.card_url, isPending: false })
                })
        }
    }
    fetchSignins () {
        this.setState({ isSigninsPending: true })
        axios.get(`/api/schedule/${this.props.params.id}/signins`, {
            params: {
                offset: this.state.signinsOffset,
                t: Date.now(),
            }
        })
            .then(res => {
                const data = res.data.data
                const top_signins = data.top_signins.map(item => ({ ...item, isHot: true }))
                const normalSignins = this.state.signins.concat(data.signins)
                const signins = top_signins.concat(normalSignins)
                this.setState({
                    signins: signins,
                    signinsOffset: data.next_offset,
                    isSigninsPending: false,
                    signinsHasMore: data.has_more,
                })
            })
    }
    initShareInfo (shareInfo) {
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: shareInfo.share_title,
                desc: shareInfo.share_description,
                imgUrl: shareInfo.share_icon,
                link: shareInfo.share_url,
            }
        })
    }
    onClickReply () {
        setTimeout(() => this.$textarea.focus(), 300)
        this.setState({ isShowCommentDialog: true, isShowActionSheet: false })
    }
    toQrImg (str) {
        qrcode.toDataURL(str, {
            errorCorrectionLevel: 'M',
            margin: 4,
            type: 'image/png',
        }, (err, url) => {
            if (err) throw err
            this.setState({ qrImg: url })
        })
    }
    onClickReceiveBtn (action) {
        axios.post(`/api/schedule/${this.props.params.id}/signup`, qs.stringify({
            accept_notify: action !== 'cancle'
        }))
        this.state.scheduleInfo.access_info.participate = true
        this.setState({ isShoweReceiveDialog: false, scheduleInfo: this.state.scheduleInfo })
    }
    onClickQrOk () {
        this.onClickReceiveBtn('cancle')
        this.setState({ isShowQrDialog: false })
    }
    getOffsetTimeStr (now, future) {
        const offsetTimestamp = future - now
        if (offsetTimestamp < 0) {
            return '0分钟'
        }
        if (offsetTimestamp < 3600000) {
            return Math.ceil(offsetTimestamp / 60 / 1000) + '分钟'
        }
        if (offsetTimestamp > 86400000) {
            return ~~(offsetTimestamp / 86400000) + '天'
        } else {
            return ~~(offsetTimestamp / 3600000) + '小时'
        }
    }
    onClickLike (id, i) {
        const type = this.state.signins[i].liked ? 'cancel_like' : 'like'
        axios.post(`/api/schedule/${this.props.params.id}/signin/${id}/${type}`)
        // 暂时先为了方便
        this.state.signins[i].liked = !this.state.signins[i].liked
        if (this.state.signins[i].likes.some(item => item.account.id === this.props.account.id)) {
            this.state.signins[i].likes = this.state.signins[i].likes.filter(item => item.account.id !== this.props.account.id)
            this.setState({ signins: this.state.signins })
        } else {
            this.state.signins[i].likes.push({account: this.props.account})
            this.setState({ signins: this.state.signins })
        }
    }
    onClickComment (signinId, id, signinIndex, commentIndex) {
        // 直接点评论按钮
        if (!id) {
            setTimeout(() => this.$textarea.focus(), 300)
            this.setState({
                selectedComment: '', 
                isShowCommentDialog: true, 
                selectedCommentSignin: signinId, 
                selectedCommentSigninIndex: signinIndex,
            })
            // 点击评论列表
        } else {
            this.setState({
                selectedComment: id, 
                selectedCommentSignin: signinId,
                isShowActionSheet: true, 
                selectedCommentSigninIndex: signinIndex,
                selectedCommentIndex: commentIndex,
            })
        }
    }
    onSubmitComment () {
        const comment = this.state.comment.trim()
        if (!comment) {
            return this.showTip('内容不能为空')
        }
        const signinId = this.state.selectedCommentSignin
        const scheduleId = this.props.params.id
        this.setState({ isPending: true })
        axios.post(`/api/schedule/${scheduleId}/signin/${signinId}/comment/publish`, qs.stringify({
            content: this.state.comment,
            quote_id: this.state.selectedComment,
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.state.signins[this.state.selectedCommentSigninIndex].comments.push({
                    account: res.data.data.account,
                    content: comment,
                    id: res.data.data.id,
                    quote: res.data.data.quote_account,
                })
                this.setState({ isShowCommentDialog: false, comment: '', signins: this.state.signins })
            })
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    onAudioLoad () {
        const $player = this.$player
        this.setState({ audioDuration: ~~$player.duration })
    }
    onAudioTimeUpdate () {
        const currentTime = this.$player.currentTime
        // console.log(this.$player.currentTime)
        // audioDuration是四舍五入的，有精度问题
        if (currentTime + 0.5 >= this.state.audioDuration) {
            this.setState({ audioStatus: 'pause', audioCurrentTime: 0 })
        } else {
            this.setState({ audioCurrentTime: ~~this.$player.currentTime })
        }
    }
    onPlay () {
        // console.log('play')
    }
    onPause () {
        // console.log('pause')
    }
    onClickAudio (i) {
        const $player = this.$player
        // 如果前后点击的音频不一样
        if (this.state.selectedAudioIndex !== i) {
            this.setState({
                audioCurrentTime: 0,
                audioSrc: this.state.signins[i].signin.audio_url,
                selectedAudioIndex: i,
                audioDuration: this.state.signins[i].signin.audio_length,
                audioStatus: 'playing',
            }, () => {
                $player.pause()
                $player.currentTime = 0
                $player.play()
            })
        } else {
            this.setState({ audioStatus: $player.paused ? 'playing' : 'pause' })
            $player.paused ? $player.play() : $player.pause()
        }
    }
    onClickDelComment () {
        this.setState({ isShowDelConfirmDialog: true, isShowActionSheet: false })
    }
    onClickDelCommentOk () {
        const scheduleId = this.props.params.id
        const signinId = this.state.selectedCommentSignin
        const commentId = this.state.selectedComment
        const selectedSigninIndex = this.state.selectedCommentSigninIndex
        const selectedCommentIndex = this.state.selectedCommentIndex
        axios.post(`/api/schedule/${scheduleId}/signin/${signinId}/comment/${commentId}/delete`)
        this.state.signins[selectedSigninIndex].comments = this.state.signins[selectedSigninIndex].comments.filter((item, i) => i !== selectedCommentIndex)
        this.setState({ signins: this.state.signins, isShowDelConfirmDialog: false, selectedCommentIndex: '' })
    }
    onClickDelSignin(id, index) {
        this.setState({ selectedSigninId: id, selectedSigninIndex: index, isShowDelSigninDialog: true })
    }
    onClickDelSigninOk() {
        axios.post(`/api/schedule/${this.props.params.id}/signin/${this.state.selectedSigninId}/delete`)
        this.state.signins = this.state.signins.filter((item, i) => i !== this.state.selectedSigninIndex)
        this.setState({ signins: this.state.signins, isShowDelSigninDialog: false })
    }
    onClickJoin (process, isCanJoin) {
        if (process === 'close') {
            return
        }
        if (!isCanJoin) {
            return this.setState({ isShowCanNotJoinDialog: true })
        }
        if (this.state.scheduleInfo.schedule && this.state.scheduleInfo.schedule.signup_mode === 'pay') {
            location.assign(`/lecture/schedule_pay?schedule_id=${this.props.params.id}`)
            return
        }
        if (this.state.isSubscribe) {
            this.setState({ isShoweReceiveDialog: true })
        } else {
            axios.post(`/api/schedule/${this.props.params.id}/signup_qrcode`)
                .then(res => {
                    this.toQrImg(res.data.data.qrcode_content)
                })
            this.setState({ isShowQrDialog: true })
        }
    }
    onClickCount (isStart) {
        if (isStart) {
            location.assign(`/schedule/${this.props.params.id}/rank`)
        }
    }
    onClickLiveroomFollow (e) {
        e.stopPropagation()
        this.props.dispatch({
            type: 'SHOW_FOLLOW_LIVEROOM',
            payload: {
                liveroom: this.state.liveroom,
                callback: () => this.setState({
                    isLocalFollowed: true
                })
            }
        })
        // location.assign(`/liveroom/${this.state.liveroom.id}`)
        // axios.post(`/api/liveroom/${this.state.liveroom.id}/follow?fr=schedule`)
        // this.state.sche
        // this.setState({ isFans: true })
    }
    getLongNum (num) {
        if (num < 1e4) {
            return num
        } else {
            return `${+(num / 1e4).toFixed(2)}万+`
        }
    }
    onClickHideDesc () {
        this.setState({ isShowDesc: false })
        this.$descContent.scrollIntoView()
    }
    onClickSignin () {
        // 因为安卓可能会发生sdk加载失败的情况
        if (window.systemType === 'android') {
            location.assign(`/schedule/${this.props.params.id}/signin/create`)
        } else {
            location.assign(`/schedule/${this.props.params.id}/signin/create`)
        }
    }
    getBottomText (schedule, isCanJoin) {
        if (schedule.process === 'close') {
            return '活动已结束'
        } else {
            if (!isCanJoin) {
                return '报名截止'
            } else {
                return '参与打卡'
            }
        }
    }
    getIsShowBottomBtn (schedule, process, role, access_info) {
        if (this.state.isPending) {
            return false
        }
        return schedule.process === 'close' || (process !== 'close' && !role.is_manager && !access_info.participate)
    }
    render() {
        const scheduleInfo = this.state.scheduleInfo
        const schedule = scheduleInfo.schedule || {}
        const liveroom = this.state.liveroom
        const rank = scheduleInfo.rank || {}
        const stats_info = scheduleInfo.stats_info || {}
        const role = scheduleInfo.role || {}
        const signin_info = scheduleInfo.signin_info || {}
        const access_info = scheduleInfo.access_info || {}
        const account = this.props.account
        const selectedSigninInfo = this.state.signins[this.state.selectedCommentSigninIndex]
        // not_start starting close
        const process = schedule.process
        const now = Date.now()
        // const offsetBeginTimestamp = now - schedule.beg_timestamp * 1000
        // const offsetEndTimestamp = now - schedule.end_timestamp * 1000
        
        let actionSheetMenu
        if (this.state.selectedComment === '' || !selectedSigninInfo || this.state.selectedCommentIndex === '') {
            actionSheetMenu = this.menu
        } else {
            if ((selectedSigninInfo.comments[this.state.selectedCommentIndex].account.id === account.id) || role.is_manager) {
                actionSheetMenu = this.managerMenu
            } else {
                actionSheetMenu = this.menu
            }
        }
        // 付费模式
        const isPayMode = schedule.signup_mode === 'pay'
        // 开启奖金
        const isBonus = schedule.bonus_flag
        // 有没有能获取奖金资格的人
        const hasBonusCount = stats_info.bonus_carve_count > 0
        // 是不是订阅公众号又关注了直播间
        const isFollowed = (this.state.isFans && this.props.account.subscribed) || this.state.isLocalFollowed
        // 是否显示底部按钮
        const isShowBottomBtn = this.getIsShowBottomBtn(schedule, process, role, access_info)
        // 天数是否还可以满足参与打卡
        const isCanJoin = schedule.total_day - (schedule.current_day - 1) >= schedule.bonus_condition_day
        // 底部按钮文案
        const bottomBtnText = this.getBottomText(schedule, isCanJoin)
        
        return (
            <Page>
                <audio
                    ref={r => this.$player = r}
                    preload="metadata"
                    src={this.state.audioSrc}
                    width="1"
                    height="1"
                    onCanPlay={e => e}
                    onTimeUpdate={e => this.onAudioTimeUpdate()}
                    onPlay={e => this.onPlay()}
                    onPause={e => this.onPause()}
                />
                <div className="schedule-page wk-inner-page">
                    <div className="dashboard margin-bottom">
                        <div className="header">
                            <WKVisible create={true}>
                                <button className="invite-btn" onClick={e => location.assign(`/schedule/${this.props.params.id}/sharecard`)}>
                                    邀请好友
                                </button>
                            </WKVisible>
                            <div className="avatar" style={{backgroundImage: `url(${schedule.banner})`}}>
                            </div>
                            <div className="content">
                                <div className="title">
                                    {schedule.name || ''}
                                </div>
                                <div className="days">
                                    <WKVisible create={process === 'not_start'}>
                                        打卡活动于{this.getOffsetTimeStr(now, schedule.beg_timestamp * 1000)}后开始
                                    </WKVisible>
                                    <WKVisible create={process === 'starting'}>
                                        第<span className='bold'>{schedule.current_day}</span>/{schedule.total_day}天
                                    </WKVisible>
                                    <WKVisible create={process === 'close'}>
                                        已结束
                                    </WKVisible>
                                </div>
                                <div className="progress">
                                    <div 
                                        className="active-progress" 
                                        style={{width: `${schedule.current_day/schedule.total_day * 100}%`}}
                                    >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="count" onClick={e => this.onClickCount(process !== 'not_start')}>
                            <div className="desc">
                                已有{stats_info.participate_count || 0}人参与
                            </div>
                            <div className="avatars">
                                {
                                    (stats_info.recently_accounts || []).map(item => (
                                        <div 
                                            className="avatar"
                                            key={item.id}
                                            style={{backgroundImage: `url(${item.avatar_url})`}}
                                        >
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    
                    {/* 奖金面板 */}
                    <WKVisible create={isPayMode}>
                        <div className="pay-panel">
                            <div className="data-wrap wk-border-line-after wk-position-rlt">
                                <div className="data-item">
                                    <div className="img">
                                        <img src={panelFeeImg} alt='报名费用' />
                                    </div>
                                    <div className="title">￥{renderMoney(schedule.signup_fee)}</div>
                                    <div className="intro">报名费用</div>
                                </div>
                                {
                                    isBonus && (
                                        <div className="data-item" onClick={e => this.setState({ isShowPayQuestionDialog: true })}>
                                            <div className="img">
                                                <img src={panelRewardImg} alt='奖金池' />
                                            </div>
                                            <div className="title">￥{renderMoney(stats_info.bonus_pools)}</div>
                                            <div className="intro">奖金池</div>
                                        </div>
                                    )
                                }
                                
                                <div className="data-item">
                                    <div className="img">
                                        <img src={panelTimeImg} alt='打卡天数' />
                                    </div>
                                    <div className="title">{schedule.total_day}</div>
                                    <div className="intro">打卡天数</div>
                                </div>
                            </div>
                            <WKVisible create={isBonus}>
                                <div className="footer">
                                    {/* <span className="green">奖金领取条件：</span> */}
                                    <span className="green">坚持打卡{schedule.bonus_condition_day}天，平分奖金池</span>
                                    <img onClick={e => this.setState({ isShowPayQuestionDialog: true })} src={questionImg} />
                                </div>
                            </WKVisible>
                        </div>
                    </WKVisible>
                    
                    {/* 打卡面板 */}
                    <WKVisible create={process !== 'not_start' && (access_info.participate || role.is_manager)}>
                        <div 
                            className={`schedule-btn-wrap ${(signin_info.id != null || process === 'close') ? 'small' : ''}`}
                            style={(isBonus && process === 'close' && hasBonusCount) ? {height: '160px'} : {}}
                        >
                            <WKVisible create={signin_info.id == null && process === 'starting'}>
                                <div className="no-signin">
                                    <div className="btn-big"></div>
                                    <div 
                                        className="btn-small" 
                                        onClick={e => this.onClickSignin()}
                                    >
                                        去打卡
                                    </div>
                                    <div className="rank-btn" onClick={e => location.assign(`/schedule/${this.props.params.id}/rank`)}>
                                        {'>> 查看排行榜 <<'}
                                    </div>
                                </div>
                            </WKVisible>
                            <WKVisible create={signin_info.id != null}>
                                <div className="has-signin">
                                    <div className="title" onClick={e => this.fetchAchieveImg()}>
                                        <img src={signinImg} alt='已打卡' />
                                        <span>今日已经打卡，点击获取成就卡</span>
                                    </div>
                                </div>
                            </WKVisible>
                            <WKVisible create={process === 'close'}>
                                <div className="has-signin">
                                    <div className="title" onClick={e => this.fetchAchieveImg()}>
                                        <img src={signinDisabledImg} alt='已结束' />
                                        <span className='grey'>打卡活动已结束，点击获取成就卡</span>
                                        <WKVisible create={isBonus && hasBonusCount} className='grey bonus text-center'>
                                            <p>{stats_info.bonus_carve_count}人平分奖金池 ¥{renderMoney(stats_info.bonus_pools)}</p>
                                            <p>奖金自动发放到个人中心钱包</p>
                                        </WKVisible>
                                    </div>
                                </div>
                            </WKVisible>
                            <WKVisible create={signin_info.id != null || process === 'close'}>
                                <div 
                                    className="rank-btn top100"
                                    onClick={e => location.assign(`/schedule/${this.props.params.id}/rank`)}
                                >
                                    <WKVisible create={isBonus && process === 'close' && hasBonusCount}>
                                        {'>> 查看获奖名单 <<'}
                                    </WKVisible>
                                    <WKVisible create={!isBonus || process !== 'close' || !hasBonusCount}>
                                        {'>> 查看排行榜 <<'}
                                    </WKVisible>
                                </div>
                            </WKVisible>
                        </div>
                        <Cell 
                            access 
                            className='my-rank wk-bg-white margin-bottom'
                            onClick={e => location.assign(`/schedule/${this.props.params.id}/calendar`)}
                        >
                            <CellHeader>
                                <div className="avatar" style={{backgroundImage: `url(${account.avatar_url})`}}></div>
                            </CellHeader>
                            <CellBody>
                                <div className="title">累计打卡<span className='bold'>{rank.cumulative_days}</span>天</div>
                                <div className='rank'>当前排名：{rank.rank}</div>
                            </CellBody>
                            <CellFooter className='footer'>
                                打卡日历
                            </CellFooter>
                        </Cell>
                    </WKVisible>
                    
                    {/* 内容介绍 */}
                    <div ref={r => this.$descContent = r}></div>
                    <WKVisible create={schedule.description || role.is_manager} className='margin-bottom desc-wrap'>
                        <WkPanel 
                            title='活动介绍' 
                            className={`desc ${this.state.isShowDesc ? 'is-show' : 'is-hide'}`}
                            isHideTip={this.state.isShowDesc || !schedule.description}
                            tip={
                                <span onClick={e => this.setState({ isShowDesc: true })}>查看详情</span>
                            }>
                            <div>
                                <WKVisible create={role.is_manager && !schedule.description}>
                                    <div className="content">
                                        <div className="empty">
                                            <img src={signinsEmptyImg} alt=""/>
                                            <div className="text">
                                                <p>填写活动介绍和激励机制</p>
                                                <p>才能激发学员学习兴趣和持续打卡</p>
                                            </div>
                                        </div>
                                    </div>
                                </WKVisible>
                                <WKVisible create={schedule.description}>
                                    <div className={`content-wrap`}>
                                        <WKVisible show={this.state.isShowDesc}>
                                            <div className="content" dangerouslySetInnerHTML={{__html: filterHTML(schedule.description)}}></div>
                                            <div className="more" onClick={e => this.onClickHideDesc()}>{'>> 点击收起 <<'}</div>
                                        </WKVisible>
                                    </div>
                                </WKVisible>
                            </div>
                        </WkPanel>
                        <div className="liveroom-info-bar wk-border-line-before" onClick={e => location.assign(`/liveroom/${liveroom.id}`)}>
                            <div className="avatar">
                                <img src={liveroom.small_avatar_url} alt='头像' />
                                <WKVisible create={liveroom.verify_type === 1}>
                                    <i className="iconfont verify-type-icon verify-type-icon-special icon-yfv"></i>
                                </WKVisible>
                                <WKVisible create={liveroom.verify_type === 2}>
                                    <i className="iconfont verify-type-icon icon-yfv"></i>
                                </WKVisible>
                            </div>
                            <div className="info">
                                <div className="title text-ellipsis">{liveroom.name}</div>
                                <div className="desc">
                                    <span className="follow-count margin-right">{this.getLongNum(liveroom.fans_count)}人关注</span>
                                    <span className="hot-count">{this.getLongNum(liveroom.popular)}人气</span>
                                </div>
                            </div>
                            <WKVisible tag={null} create={isFollowed && !role.is_manager}>
                                <Button disabled>已关注</Button>
                            </WKVisible>
                            <WKVisible tag={null} create={!isFollowed && !role.is_manager}>
                                <Button onClick={e => this.onClickLiveroomFollow(e)}>关注</Button>
                            </WKVisible>
                        </div>
                    </WKVisible>
                    
                    {/* 动态列表 */}
                    <ScheduleDetailSignins
                        signins={this.state.signins}
                        signinsCount={stats_info.all_signin_count}
                        onClickLike={(id, i) => this.onClickLike(id, i)}
                        onClickComment={(signinId, commentId, signinIndex, commentIndex) => this.onClickComment(signinId, commentId, signinIndex, commentIndex)}
                        onClickAudio={i => this.onClickAudio(i)}
                        audioCurrentTime={this.state.audioCurrentTime}
                        audioStatus={this.state.audioStatus}
                        selectedAudioIndex={this.state.selectedAudioIndex}
                        onClickDelSignin={(id, index) => this.onClickDelSignin(id, index)}
                        role={role}
                        process={process}
                    />

                    <WKInfiniteScroll 
                        onTouchBottom={() => this.fetchSignins()}
                        isStop={this.state.isSigninsPending}
                        isKill={!this.state.signinsHasMore}
                        isShowLoading={true}
                    />
                    <Dialog type="ios" title='' buttons={[
                        { label: '关闭', onClick: () => this.onClickQrOk() }
                    ]} show={this.state.isShowQrDialog}>
                        <div className="qr-dialog">
                            <div className="text">
                                长按扫码，接收打卡提醒
                            </div>
                            <img src={this.state.qrImg} alt='二维码' />
                        </div>
                    </Dialog>
                    <Toast icon="loading" show={this.state.isPending}></Toast>
                    <WKVisible 
                        create={isShowBottomBtn} 
                        className={`process-${schedule.process} ${!isCanJoin ? 'can-not-join' : ''}`}
                    >
                        <WKBottomBtn btnContent={{
                            text: bottomBtnText,
                            method: () => this.onClickJoin(schedule.process, isCanJoin)
                        }}/>
                    </WKVisible>
                    <Dialog type="ios" title='' buttons={[
                        { label: '取消', type: 'default', onClick: () => this.onClickReceiveBtn('cancle') },
                        { label: '确定', onClick: () => this.onClickReceiveBtn() }
                    ]} show={this.state.isShoweReceiveDialog}>
                        是否接收打卡提醒？
                    </Dialog>
                    <Dialog type="ios" title='' buttons={[
                        { label: '删除', type: 'default', onClick: () => this.onClickDelCommentOk() },
                        { label: '取消', onClick: () => this.setState({ isShowDelConfirmDialog: false }) }
                    ]} show={this.state.isShowDelConfirmDialog}>
                        确定删除评论吗？
                    </Dialog>
                    <WKCommentDialog type="ios" title='请输入评论' buttons={[
                        { label: '取消', type: 'default', onClick: e => this.setState({ isShowCommentDialog: false }) },
                        { label: '提交', onClick: e => this.onSubmitComment() }
                    ]} show={this.state.isShowCommentDialog}>
                        <textarea 
                            rows="4"
                            onChange={e => this.setState({ comment: e.target.value })}
                            value={this.state.comment}
                            ref={r => this.$textarea = r}
                        >
                        </textarea>
                    </WKCommentDialog>
                    <Dialog type="ios" title='' buttons={[
                        { label: '确定', type: 'default', onClick: e => this.onClickDelSigninOk() },
                        { label: '取消', onClick: e => this.setState({ isShowDelSigninDialog: false }) }
                    ]} show={this.state.isShowDelSigninDialog}>
                        确定删除动态吗？
                    </Dialog>
                    <Dialog type="ios" title='' buttons={[
                        { label: '确定', onClick: e => browserHistory.go(-1) }
                    ]} show={this.state.isShow404}>
                        该打卡活动已被删除
                    </Dialog>
                    <Dialog type="ios" title='奖金领取说明' buttons={[
                        { label: '知道了', onClick: e => this.setState({ isShowPayQuestionDialog: false }) }
                    ]} show={this.state.isShowPayQuestionDialog}>
                        <div className="text-left">
                            活动结束后第二天20:00，系统自动发放奖金到个人中心钱包
                        </div>
                    </Dialog>
                    <Dialog type="ios" title='' buttons={[
                        { label: '好', onClick: e => this.setState({ isShowCanNotJoinDialog: false }) }
                    ]} show={this.state.isShowCanNotJoinDialog}>
                        由于现在报名，并坚持每天打卡无法满足奖金瓜分条件，因此截止报名，感谢您的理解
                    </Dialog>
                    <ActionSheet
                        menus={actionSheetMenu}
                        actions={[{
                            label: '取消',
                            onClick: e => this.setState({isShowActionSheet: false})
                        }]}
                        show={this.state.isShowActionSheet}
                        type="ios"
                        onRequestClose={e => this.setState({isShowActionSheet: false})}
                    />
                    <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                    {/* 成就卡modal */}
                    <WKVisible create={this.state.isshowAchieve && !this.state.isPending} className="achieve-card">
                        <Mask onClick={e => this.setState({ isshowAchieve: false })} />
                        <div className="img-wrap">
                            <img src={this.state.achieveImg} alt='成就卡' className='achieve-card-img' />
                            <div className="achieve-card-bottom" style={{backgroundImage: `url(${achieveCardBottomImg})`}}>
                            
                            </div>
                        </div>
                    </WKVisible>
                    <FollowLiveroom />
                    <WKVisible create={role.is_manager}>
                        <ScheduleDetailOperation
                            id={this.props.params.id}
                        />
                    </WKVisible>
                </div>
            </Page>
        )
    }
}


export default connect(state => ({
    account: state.account,
}))(SchedulePage)


// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleDetailPage.js